import React from "react";

import "./About.scss";
export default function About() {
  return (
    <div className="about">
      <h1 className="about__title">About this app</h1>
      <div className="about__qrcode-wrap">
        {" "}
        <p className="about__qr-code-text">
          Use this QR code to go to the live version of this application.
        </p>
        <div className="about__qrcode"></div>{" "}
      </div>
      <p className="about__text">
        This simple web application was built to support landlords and tenants
        make purchasing decisions. It is aimed to provide transparency when
        tenants are search for landlords to rent from.{" "}
      </p>
      <h1 className="about__title"> Key features</h1>
      <p className="about__text">
        This application perform the certain functions for landlords:{" "}
      </p>
      <ul className="about__list-wrapper">
        <li className="about__list">Search a landlord name</li>
        <li className="about__list">Create a listing</li>
        <li className="about__list">Edit a listing</li>
        <li className="about__list">Delete a listing</li>
        <li className="about__list">Review a landlord</li>
        <li className="about__list">Add a review on a landlord listing</li>
        <li className="about__list">Star reviews are automatically averaged</li>
      </ul>
      <h1 className="about__title"> Tech used</h1>
      <ul className="about__list-wrapper">
        <li className="about__list">React</li>
        <li className="about__list">React Star Rating Library</li>
        <li className="about__list">Google Maps API</li>
        <li className="about__list">BootStrap</li>
        <li className="about__list">Express.js</li>
        <li className="about__list">NodeJS</li>
      </ul>
    </div>
  );
}
